import { isSSR } from "./ssr";

export const isApproachGuidesVersion = (locationSearch: string) => {
  if (isSSR()) return false;

  const withInsiderParam = hasInsiderQueryParam(locationSearch);
  const isCopilotEnabled = !!window.document
    .querySelector<HTMLHtmlElement>("html")
    ?.classList.contains("ag-copilot-enabled");

  return isCopilotEnabled || withInsiderParam;
};

export const approachGuidesInsiderValue = (locationSearch: string) => {
  const searchParams = new URLSearchParams(locationSearch);
  const insiderValue = searchParams.get("insider");
  return insiderValue;
};

const hasInsiderQueryParam = (locationSearch: string) => {
  const searchParams = new URLSearchParams(locationSearch);
  return searchParams.has("insider");
};
